module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/fuel-consumption-report/fuel-consumption-report.component.css
// module id = ./src/app/fuel-consumption-report/fuel-consumption-report.component.css
// module chunks = main